export default __webpack_public_path__ + "static/media/dc_logo.fc3b0bab.png";